// Ids dos usuarios que este usuario acompanha (supervisao).
export const idsAcompanhados = user => {
  let v = user?.acompanha;
  if (typeof v === "string") {
    try { v = JSON.parse(v); } catch (e) { v = []; }
  }
  return Array.isArray(v) ? v.map(Number).filter(Boolean) : [];
};

// O ticket e meu ou de alguem que eu acompanho?
export const ticketEhMeu = (ticket, user) =>
  !!ticket?.userId && (ticket.userId === user?.id || idsAcompanhados(user).includes(Number(ticket.userId)));
